


import React from 'react';

const NgHeroSection = () => {
  return (
    <section className="relative bg-white overflow-hidden text-gray-800 mb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pt-10 md:pt-14 pb-4 md:pb-8">
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-start lg:items-center">

          {/* Left: Text */}
          <div className="text-center lg:text-left space-y-3 md:space-y-4 lg:pr-8">
            <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-black/80 mb-1 md:mb-2 text-center lg:text-left">
              Built for Nigerian merchants
            </p>
            <div className="space-y-3 md:space-y-4">
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-6xl font-bold tracking-tight text-black leading-tight">
                Turn every POS transaction into a{' '}
                <span className="bg-gradient-to-r from-[#8ae690] to-[#7ad67f] bg-clip-text text-transparent">
                  repeat sale.
                </span>
              </h1>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto lg:mx-0">
                Connect your POS in 60 seconds. WhatsApp, SMS, and ads run themselves.
              </p>
            </div>

            <div className="flex flex-col gap-2 w-full max-w-2xl mx-auto lg:mx-0">
              <div className="flex flex-col items-center sm:flex-row sm:items-center gap-3">
                <div className="flex -space-x-2 sm:-space-x-3 shrink-0">
                  {['/avatar7.png', '/avatar8.png', '/avatar9.png', '/avatar10.png'].map((src, i) => (
                    <img key={i} src={src} alt="" className="w-6 h-6 sm:w-10 sm:h-10 rounded-full border-2 border-white object-cover shadow-sm" />
                  ))}
                </div>
                <p className="text-base sm:text-lg text-gray-600 leading-relaxed text-center sm:text-left">
                  Powering Nigerian merchants.
                </p>
              </div>
              <p className="text-xs sm:text-sm text-black/70 text-center sm:text-left leading-snug px-1 sm:px-0">
                3.4× avg. revenue lift in 30 days · No card needed
              </p>
            </div>
          </div>

          {/* Right: Metrics */}
          <div className="hidden lg:flex flex-col gap-4">
            <div className="rounded-3xl p-6 bg-gradient-to-br from-white via-[#8ae690]/20 to-white border border-[#8ae690]/40 shadow-[0_20px_45px_-18px_rgba(0,0,0,0.25)]">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-black/80 mb-3">Last 30 days</p>
              <div className="flex items-end gap-4 mb-4">
                <div>
                  <p className="text-sm text-gray-600">Extra revenue unlocked</p>
                  <p className="text-4xl font-bold text-black tracking-tight">₦18.4M</p>
                </div>
                <span className="inline-flex items-center rounded-full bg-black text-white text-xs font-semibold px-3 py-1.5">
                  3.4× avg. lift
                </span>
              </div>
              <div className="grid grid-cols-3 gap-3 text-sm text-gray-700">
                <div className="rounded-2xl bg-white/80 border border-gray-100 px-3 py-3">
                  <p className="text-[11px] font-medium text-gray-500 mb-1">Moniepoint</p>
                  <p className="text-lg font-semibold text-black">₦7.2M</p>
                  <p className="text-[11px] text-emerald-600 font-medium mt-0.5">+142% reorders</p>
                </div>
                <div className="rounded-2xl bg-white/80 border border-gray-100 px-3 py-3">
                  <p className="text-[11px] font-medium text-gray-500 mb-1">OPay &amp; PalmPay</p>
                  <p className="text-lg font-semibold text-black">₦6.1M</p>
                  <p className="text-[11px] text-emerald-600 font-medium mt-0.5">3.1× repeat buyers</p>
                </div>
                <div className="rounded-2xl bg-white/80 border border-gray-100 px-3 py-3">
                  <p className="text-[11px] font-medium text-gray-500 mb-1">Nomba</p>
                  <p className="text-lg font-semibold text-black">₦5.1M</p>
                  <p className="text-[11px] text-emerald-600 font-medium mt-0.5">−41% ad spend</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div className="rounded-3xl bg-white border border-gray-100 px-4 py-4 shadow-sm">
                <p className="text-xs font-medium text-gray-500 mb-1">Customers reached</p>
                <p className="text-2xl font-bold text-black">23,418</p>
                <p className="text-[11px] text-gray-500 mt-1">via WhatsApp &amp; SMS</p>
              </div>
              <div className="rounded-3xl bg-white border border-gray-100 px-4 py-4 shadow-sm">
                <p className="text-xs font-medium text-gray-500 mb-1">Campaigns running</p>
                <p className="text-2xl font-bold text-black">58</p>
                <p className="text-[11px] text-emerald-600 mt-1">All on autopilot</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default NgHeroSection;
